import $http from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getData(context, { params, id }) {
      return new Promise((resolve, reject) => {
        $http.get(`/order-note/${id || ''}`, { params })
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    postData(context, { payload, id }) {
      return new Promise((resolve, reject) => {
        $http.post(`/order-note${id ? '/' + id : ''}`, payload)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    deleteData(context, { id }) {
      return new Promise((resolve, reject) => {
        $http.delete(`/order-note/${id || ''}`)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
     editData(context, { payload, id }) {
      return new Promise((resolve, reject) => {
        $http.put(`/order-note${id ? '/' + id : ''}`, payload)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
  },
}
